/* ============================================================
   SUMMER SALE FX — 3D cursor tilt on product cards.
   Each card is bound individually so the card under the cursor
   is always the one that responds (no wrong-item glitches).
   (Button "buy nudge" is a simple periodic CSS animation in
   theme.liquid — no JS, no cursor reactivity.)
   Guarded for reduced-motion and coarse (touch) pointers.
   ============================================================ */
(function () {
  if (window.__cdFX) return;
  window.__cdFX = true;

  var prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var finePointer = window.matchMedia('(pointer: fine)').matches;
  if (prefersReduced || !finePointer) return; // calm on touch / reduced-motion

  var MAX_TILT = 6; // degrees

  function bindCard(card) {
    if (card.__cdTilt) return;
    card.__cdTilt = true;

    card.addEventListener('pointermove', function (e) {
      var r = card.getBoundingClientRect();
      if (!r.width || !r.height) return;
      var px = (e.clientX - r.left) / r.width - 0.5;
      var py = (e.clientY - r.top) / r.height - 0.5;
      card.style.zIndex = '2';
      card.style.transform =
        'perspective(900px) rotateY(' + (px * MAX_TILT).toFixed(2) + 'deg) rotateX(' +
        (-py * MAX_TILT).toFixed(2) + 'deg) translateY(-6px)';
    }, { passive: true });

    function reset() { card.style.transform = ''; card.style.zIndex = ''; }
    card.addEventListener('pointerleave', reset, { passive: true });
    card.addEventListener('pointercancel', reset, { passive: true });
  }

  function bindAll(root) {
    (root || document).querySelectorAll('product-card, .product-card').forEach(bindCard);
  }

  bindAll();

  // Bind cards added later (quick view, lazy loading, section reloads, etc.)
  if ('MutationObserver' in window) {
    var mo = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var nodes = mutations[i].addedNodes;
        for (var j = 0; j < nodes.length; j++) {
          var n = nodes[j];
          if (n.nodeType !== 1) continue;
          if (n.matches && n.matches('product-card, .product-card')) bindCard(n);
          if (n.querySelectorAll) bindAll(n);
        }
      }
    });
    mo.observe(document.body, { childList: true, subtree: true });
  }
})();
